// // import axios from "axios";
// // import { HOST } from "../constrants";
// // import setAuthToken from "../utils/setAuthToken";
import { setAlert } from "./alert";
import {
  AUTH_ERROR,
  CLEAR_PROFILE,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  REGISTER_FAIL,
  REGISTER_SUCCESS,
  USER_LOADED,
} from "./types";

import { firebase } from "../firebase";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  updateProfile,
} from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";

const auth = getAuth(firebase);
const db = getFirestore(firebase);

// // Load User
export const loadUser = () => async (dispatch) => {
  try {
    setTimeout(async () => {
      const res = auth.currentUser;

      dispatch({
        type: USER_LOADED,
        payload: {
          displayName: res.displayName,
          accessToken: res.accessToken,
          email: res.email,
          uid: res.uid,
        },
      });
    }, 2000);
  } catch (error) {
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

// Register User

export const register =
  ({ name, email, password, phone }) =>
  async (dispatch) => {
    try {
      // Firebase - register user.
      const docRef = doc(db, "usernames", email);
      const docSnap = await getDoc(docRef);
      if (!docSnap.exists()) {
        const res = await createUserWithEmailAndPassword(auth, email, password);
        await updateProfile(res.user, {
          displayName: name,
          photoURL: null,
          phone: phone,
        });
        await setDoc(doc(db, "usernames", name), {
          email: email,
          uid: res.user.uid,
        });
        res.user.displayName = name;
        dispatch({
          type: REGISTER_SUCCESS,
          payload: { data: res.user, name },
        });
        dispatch(loadUser(name));
        const resForLogin = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { data: res.user },
        });

        dispatch(loadUser());
        return res;
      } else {
        dispatch(setAlert("EMAIL ALREADY TAKEN", "danger"));
      }
    } catch (error) {
      dispatch(setAlert(error.message, "danger"));
      dispatch({
        type: REGISTER_FAIL,
      });
    }
  };

// Login User
export const login =
  ({ email, password }) =>
  async (dispatch) => {
    // const config = {
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // };

    // const body = JSON.stringify({ username, password });

    try {
      // Firebase - login user.

      const res = await signInWithEmailAndPassword(auth, email, password);
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { data: res.user },
      });

      dispatch(loadUser());

      return res;
    } catch (error) {
      dispatch(setAlert(error.message, "danger"));
      dispatch({
        type: LOGIN_FAIL,
      });
    }
  };

// Logout User / Clear profile
export const logout = () => async (dispatch) => {
  // logout call
  try {
    await signOut(auth);

    dispatch({
      type: CLEAR_PROFILE,
    });
    dispatch({
      type: LOGOUT,
    });
  } catch (error) {
    dispatch(setAlert(error.message, "danger"));
  }
};
